/**
 * @template {string} T
 * @typedef {T extends `${infer Head} ${infer Tail}` ? `${Lowercase<Head>}-${KebabCase<Tail>}` : Lowercase<T>} KebabCase
 */

/**
 * @template {string} T
 * @param {T} str
 * @returns {KebabCase<T>}
 */
export const toKebabCase = str => {
  var _str$match;
  return (_str$match = str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) === null || _str$match === void 0 ? void 0 : _str$match.map(x => x.toLowerCase()).join('-');
};